import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

import Loader from "../../../components/Common/Loader/Loader";
import ManageCategoryList from "../../../components/ManageCategory/ManageCategoryList/ManageCategoryList";
import NotFound from "../../../components/NotFound/NotFound";

import messages from "../../../locale/messages";

import { getUserCategoryQuery } from "../../../lib/graphql";
import getCategorySearch from "./getCategorySearch.graphql";
import getUser from "./getUser.graphql";
import useQueryResponse from "../../../lib/hooks/useQueryResponse";


const ManageCategory = ({ id, intl: { formatMessage } }) => {

    const { loading, data: getCategorySearchResult, refetch: refetchCategorySearch } = useQueryResponse({
        query: getCategorySearch,
        variables: {
            searchList: ''
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
    const { loading: userCategoryLoding, data: userCategoryDetails } = useQueryResponse({
        query: getUserCategoryQuery,
        variables: {
            profileId: id,
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
    const { loading: userDetailsLoading, data: userDetails } = useQueryResponse({
        query: getUser,
        variables: {
            id: id,
            userType: 2
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
    const firstName = useMemo(() => {
        if (userDetails?.getUser?.status === 200) {
            return userDetails?.getUser?.result?.profile?.firstName
        }
        return null
    }, [userDetails])

    if (!userDetailsLoading && !userDetails?.getUser?.result?.id) {
        return <NotFound title={formatMessage(messages.pageNotFound)} />
    } else {
        return (
            <Loader type={"page"} show={loading || userCategoryLoding}>
                {
                    !loading && !userCategoryLoding && !userDetailsLoading &&
                    <ManageCategoryList
                        userCategoryDetails={userCategoryDetails}
                        categoryDetails={{ ...getCategorySearchResult, refetch: refetchCategorySearch }}
                        profileId={id}
                        firstName={firstName}
                    />
                }
            </Loader>
        )
    }
}

ManageCategory.prototypes = {
    id: PropTypes.number.isRequired,
}

export default injectIntl(ManageCategory);
